import { BaseModel } from "@blue-chip/core";
import Scope from "./Scope";
import SpecCategory from "./SpecCategory";

export default class TemplateCategory extends BaseModel {
  static get belongsTo() {
    return [Scope];
  }

  static get hasMany() {
    return [SpecCategory];
  }
}
